export const SP_API = process.env.REACT_APP_SP_API_URL || 'https://api.letthebeatbuild.me';

export async function fetchRhymes(word, words = []) {
  const response = await fetch(`${SP_API}/api/booth/rhymes`, {
    method: 'POST',
    credentials: 'omit',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ word, words }),
  });
  if (!response.ok) throw new Error(`Rhyme lookup failed: ${response.status}`);
  return response.json();
}
